import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useChatStatusRealtime = () => {
  const queryClient = useQueryClient();
  
  useEffect(() => {
    // Subscribe to notification_chat changes
    const chatChannel = supabase
      .channel('chat-status-realtime')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notification_chat'
        },
        (payload) => {
          const data = payload.new || payload.old;
          if (data && 'notification_id' in data && data.notification_id) {
            // Invalidate only this specific notification's chat status
            queryClient.invalidateQueries({ 
              queryKey: ['notification-chat-status', data.notification_id] 
            });
          }
        }
      )
      .subscribe();

    // Subscribe to notification_chat_read_status changes
    const readStatusChannel = supabase
      .channel('chat-read-status-realtime')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notification_chat_read_status'
        },
        (payload) => {
          const data = payload.new || payload.old;
          if (data && 'notification_id' in data && data.notification_id) {
            // Invalidate only this specific notification's chat status
            queryClient.invalidateQueries({ 
              queryKey: ['notification-chat-status', data.notification_id] 
            });
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(chatChannel);
      supabase.removeChannel(readStatusChannel);
    };
  }, [queryClient]);
};
